import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import ButtonClose from '../../../../../../components/UI/Button/IconButton'
import {useLimpieza} from '../../../../../../hooks/useLimpieza'
import {TabLimpiezaModel} from '../../../../../../models'
import {CleaningScheduleForm} from '../form/cleaning-schedule'
import CalendarCleaningSchedule from '../components/calendar-cleaning-schedule'
import {TableActivitiesByScheduleWrapper} from '../table/activities'
const CleaningScheduleTab = () => {
  const {currentTabItem, changeCurrentTabItem} = useLimpieza()

  const handleBack = () => {
    const obj: TabLimpiezaModel = {
      ...currentTabItem,
      showPanel: false,
      idToEdit: '',
      currentExternalTab: 0,
    }
    changeCurrentTabItem(obj)
  }

  return (
    <div className='sdx_content_tab_panel'>
      <ButtonClose onClick={handleBack} color='#283897' />
      <Tabs
        className={'sdx_sub_react_tab_panel '}
        selectedIndex={currentTabItem.currentExternalTab}
        onSelect={(index) => {
          const obj: TabLimpiezaModel = {
            ...currentTabItem,
            currentExternalTab: index,
          }
          changeCurrentTabItem(obj)
        }}
      >
        <TabList className={'sdx_sub_tab_panel p-0'}>
          <Tab className={'sdx_sub_tab_panel_option'}>Actualizar Registro</Tab>
          <Tab className={'sdx_sub_tab_panel_option'}>Actividades</Tab>
          <Tab className={'sdx_sub_tab_panel_option'}>Vista de Programación</Tab>
        </TabList>
        <TabPanel>
          <CleaningScheduleForm />
        </TabPanel>
        <TabPanel>
          <TableActivitiesByScheduleWrapper />
        </TabPanel>
        <TabPanel>
          <CalendarCleaningSchedule />
        </TabPanel>
      </Tabs>
    </div>
  )
}

export default CleaningScheduleTab
